import { IEnumOption } from '../interfaces/enumOptions';

const getEnumOptionLabel = (
	enumOptions: IEnumOption[],
	value: string | number,
) => enumOptions.find(opt => opt.value === value)?.label;

export default getEnumOptionLabel;
